import { supabase } from "@/integrations/supabase/client";

export async function getSessionUser() {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  return session?.user ?? null;
}
